import { AnalyticsSkuViewed, type AnalyticsSkuViewedProps } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import type { CardOfferButtonMetadata } from '@cc-shopping/ui/composites/CreditCardOfferButton';
import { FadedEdgesContainer } from '@cc-shopping/ui/composites/FadedEdgesContainer';
import { Box, type BoxProps } from '@mui/material';
import { type MouseEventHandler, type MutableRefObject, type RefObject, useEffect, useRef } from 'react';
import { CreditCardOfferButtonContainer } from '../CardOfferButtonContainer';
type SegmentAnalytics = Omit<AnalyticsSkuViewedProps, 'children'>;
export type CardOfferButtonWithAnalytics = {
  segmentAnalytics: SegmentAnalytics;
} & CardOfferButtonMetadata;
interface Props {
  cardOfferButtons: CardOfferButtonWithAnalytics[];
  dragProps: {
    ref: MutableRefObject<HTMLElement | null>;
    onMouseDown?: MouseEventHandler;
    setRef?: (ref: RefObject<HTMLElement | null>) => void;
  };
  isDragging?: boolean;
}
export const HorizontalScrollableCardList = ({
  cardOfferButtons,
  dragProps,
  isDragging
}: Props) => {
  const localRef = useRef<HTMLElement | null>(null);
  useEffect(() => {
    if (dragProps.setRef) {
      dragProps.setRef(localRef);
    }
  }, [localRef.current]);
  const overrideRef = typeof dragProps.setRef !== 'undefined' ? localRef : dragProps.ref;
  return <Box sx={{
    display: 'flex',
    flexDirection: 'row'
  }}>
      <FadedEdgesContainer<BoxProps> Component={Box} className="card-carousel" showEndFadeByDefault={true} key={`carousel-${cardOfferButtons.length}`} sx={{
      display: 'flex',
      overflowX: 'auto',
      cursor: isDragging ? 'grabbing' : 'grab',
      width: {
        xs: 'min(100vw,calc(768px + 2rem))',
        md: 'min(100vw,calc(768px + 6rem))'
      }
    }} overrideRef={overrideRef} onMouseDown={dragProps.onMouseDown}>
        {cardOfferButtons.map((cardOfferButton, index) => {
        const {
          segmentAnalytics
        } = cardOfferButton;
        return <Box key={`${segmentAnalytics.impressionSection}-${cardOfferButton.id}`} sx={{
          ml: index === 0 ? 'auto' : 0,
          mr: index === cardOfferButtons.length - 1 ? 'auto' : 0
        }}>
              <Box sx={{
            width: '150px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
                <AnalyticsSkuViewed direction="horizontal" scrollableAncestor={overrideRef.current ?? undefined} {...segmentAnalytics}>
                  <Box>
                    <CreditCardOfferButtonContainer cardOfferButton={cardOfferButton} />
                  </Box>
                </AnalyticsSkuViewed>
              </Box>
            </Box>;
      })}
      </FadedEdgesContainer>
    </Box>;
};